// extracted by mini-css-extract-plugin
export default {"TextAreaContainer":"TextArea_TextAreaContainer__U8LTh","Textarea":"TextArea_Textarea__7KgwQ"};